<div class="container-fluid feedback-panel">
	<pk-broker-loader [show]="loading"></pk-broker-loader>
	<ng-container *ngIf="!loading">
		<div class="row modal-top">
			<div class="col pt-3 pb-2 pl-3">
				<a href="javascript:void(0)" class="go-back" (click)="back()"><fa-icon [icon]="['fas', 'chevron-left']"></fa-icon>Back</a>
				<button type="button" class="close" id="closeButton" (click)="activeModal.hide()" aria-label="Close">
					<span aria-hidden="true"><fa-icon [icon]="['fas', 'times']"></fa-icon></span>
				</button>
			</div>
		</div>
		<div class="row feedback-content">
			<div class="col" *ngIf="selectedFeedback === 'positive'">
				<form [formGroup]="formGroup" *ngIf="!submittedFeedback" autocomplete="off">
					<h4>We're so happy we could help you!</h4>
					<p>If you have any feedback or suggestions we would love to hear about it.</p>
					<div class="form-group">
						<textarea class="form-control" id="additionalFeedback" formControlName="body" maxlength="400" rows="4" [class.invalid]="err.body">
						</textarea>
						<span>characters left {{ charactersLeft }}/400</span>
						<div class="invalid-feedback" *ngIf="err.body">Please add a message for your feedback.</div>
					</div>
					<button type="button" class="btn btn-secondary" (click)="submit()" [disabled]="submitDisabled">{{ submitText }}</button>
					<p *ngIf="submitDisabled"><pk-broker-loader [show]="submitDisabled"></pk-broker-loader></p>
				</form>
				<ng-container *ngIf="submittedFeedback">
					<h4>Thank you!</h4>
					<p>We appreciate your feedback.</p>
				</ng-container>
			</div>
			<div class="col" *ngIf="selectedFeedback === 'negative'">
				<h4>Do you need further support?</h4>
				<p>
					The best action you can take is to email <a href="mailto:support@powerkiosk.com">support@powerkiosk.com</a> so we can address your issue
					fully.
				</p>
			</div>
		</div>
	</ng-container>
</div>
